import { parse } from 'valibot';
import useRequest from '@/shared/composables/use-request';
import { type EntityResponse, responseStatusEnum } from '@/shared/types/api';
import type { TChoices, PayloadBibliographyLink } from './../types';
import { choicesScheme } from './schemes';

class Quote {
	async fetchBibliographyLinkFormats(): EntityResponse<TChoices> {
		try {
			const response = await useRequest().$get('/other/bibliography_link_format/');

			if (response.status === responseStatusEnum.error) {
				return response;
			}

			return parse(choicesScheme, response.data);
		} catch (error) {
			throw new Error('error quote service');
		}
	}

	async fetchBibliographyLink(payload: PayloadBibliographyLink) {
		try {
			const response = await useRequest().$get('/other/bibliography_link/', {
				query: payload,
			});

			if (response.status === responseStatusEnum.error) {
				return response;
			}

			return response.data;
		} catch (error) {
			throw new Error('error quote service');
		}
	}
}

export default new Quote;
